import { createFileRoute } from "@tanstack/react-router";
import { LegacyLinkRedirect } from "@/components/signin/legacy-link";

/**
 * `/reset-password?token=…&email=…` — ссылка сброса пароля старого SSO.
 * Пароля в IEC ID нет и не будет (Д1), сбрасывать нечего.
 */
export const Route = createFileRoute("/reset-password")({
	component: LegacyLinkRedirect,
});
